export default __webpack_public_path__ + "static/media/lottery-m.1aa22032.svg";